import { useState } from "react";
import { Button, Typography } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { WDCard } from "../WDCard";
import {
  StyledButton,
  StyledButtons,
  StyledProjectTitle,
  StyledTitle,
  StyledWDCardWrapper,
  StyledWrapperSections,
} from "./styled";
import { ArrowLeft } from "../icons/ArrowLeft";
import { TransparentCollapse } from "../TransparentCollapse";
import { ContractorsModal } from "../ContractorsModal";
import { TableDoc } from "../TableDoc/TableDoc";
import { DataTableType } from "../../types/table";
import {
  EApproveStatus,
  TDocument,
  TDocumentForModal,
  TWDContractor,
} from "../../types";
import { AddCommentModal, DocumentsModal, PdfModalViewer } from "..";

export const SectionDoc = () => {
  const [openContractorsModal, setOpenContractorsModal] = useState(false);
  const [openDocumentsModal, setOpenDocumentsModal] = useState(false);
  const [openAddCommentsModal, setOpenAddCommentsModal] = useState(false);
  const [openPdfModal, setOpenPdfModal] = useState(false);
  const [document, setDocument] = useState({});
  const [choosePdf, setChoosePdf] = useState({});
  const { seriesId } = useParams<{ seriesId: string | undefined }>();

  const sectionData = {
    seriesTitle: "Алхимово",
    title: "СГП1",

    status: EApproveStatus.UPDATED,
    date: "01.01.2023",
    sectionId: "sgp1",
  };

  const data: DataTableType[] = [
    {
      key: "1",
      version: 4,
      docs: ["ПУ-1-2.4-22-РД-КЖ4.pdf", "ПУ-1-3.2-22-РД-ГП2_Изм.3.pdf"],
      createdAt: "01.01.2023",
      approvedAt: "07.01.2023",
      status: EApproveStatus.ACTUAL,
      open: (
        <Button
          type="link"
          style={{
            padding: "4px 0px 4px 30px",
          }}
          onClick={() => setOpenPdfModal(true)}
        >
          Открыть хранилище
        </Button>
      ),
    },
    {
      key: "2",
      version: 3,
      docs: [
        "ПУ-1-2.4-22-РД-КЖ3.pdf",
        "ПУ-1-3.2-21-РД-АР3.2_Задание на холодное остекление_ИЗМ2.pdf",
      ],
      createdAt: "20.12.2022",
      approvedAt: "29.12.2022",
      status: EApproveStatus.ACTUAL,
      open: (
        <Button
          type="link"
          style={{
            padding: "4px 0px 4px 30px",
          }}
        >
          Открыть хранилище
        </Button>
      ),
    },
    {
      key: "3",
      version: 2,
      docs: ["ПУ-1-2.4-22-РД-КЖ4.pdf", "ПУ-1-3.2-22-РД-ГП2_Изм.3.pdf"],
      createdAt: "01.01.2023",
      approvedAt: "07.01.2023",
      status: EApproveStatus.ACTUAL,
      open: (
        <Button
          type="link"
          style={{
            padding: "4px 0px 4px 30px",
          }}
        >
          Открыть хранилище
        </Button>
      ),
    },
    {
      key: "4",
      version: 1,
      docs: [
        "ПУ-1-2.4-22-РД-КЖ3.pdf",
        "ПУ-1-3.2-21-РД-АР3.2_Задание на холодное остекление_ИЗМ2.pdf",
      ],
      createdAt: "20.12.2022",
      approvedAt: "29.12.2022",
      status: EApproveStatus.ACTUAL,
      open: (
        <Button
          type="link"
          style={{
            padding: "4px 0px 4px 30px",
          }}
        >
          Открыть хранилище
        </Button>
      ),
    },
  ];

  const contractors: TWDContractor[] = [
    {
      id: 1,
      name: "ООО Спецстрой",
      acceptedAt: "",
      status: EApproveStatus.UPDATED,
      shortName: "ООО Спецстрой",
    },
    {
      id: 1,
      name: "ООО Западстройинвест",
      acceptedAt: "11.06.2023",
      status: EApproveStatus.ACTUAL,
      shortName: "ООО Западстройинвест",
    },
    {
      id: 1,
      name: "ИП Фирсов Евгений Никитич",
      acceptedAt: "08.06.2023",
      status: EApproveStatus.ACTUAL,
      shortName: "ИП Фирсов Евгений Никитич",
    },
  ];

  const currentDocument: TDocument = {
    id: 1,
    name: "ПУ-1-3.2-21-РД-АР3.2_Задание_на_установку_дополнит...ИЗМ4.pdf",
    revisionNumber: 5, // Версия файла
    isUpdated: false,
  };

  const selectedDocument: TDocumentForModal = {
    documents: [
      {
        id: 2,
        name: "ПУ-1-3.2-22-РД-КЖ2.4.pdf",
        revisionNumber: 4, // Версия файла
        isUpdated: false,
      },
      {
        id: 3,
        name: "ПУ-3.2-23-РД-КЖ2.4.pdf",
        revisionNumber: 2, // Версия файла
        isUpdated: true,
      },
      {
        id: 4,
        name: "ПУ-3.2-21-РД-КЖ2.4.pdf",
        revisionNumber: 2, // Версия файла
        isUpdated: false,
      },
    ],
    title: <>Актуальная РД — версия 5</>,
  };

  const navigate = useNavigate();

  return (
    <StyledWrapperSections>
      {openContractorsModal && (
        <ContractorsModal
          contractors={contractors}
          title="Актуальность РД – подрядчики"
          onCancel={() => setOpenContractorsModal(false)}
        />
      )}

      {openDocumentsModal && (
        <DocumentsModal
          currentDocument={currentDocument}
          selectedDocument={selectedDocument}
          onCancel={() => setOpenDocumentsModal(false)}
          onChoosePdf={(doc) => {
            setChoosePdf(doc);
          }}
          onOpenAddCommentModal={(document) => {
            setOpenDocumentsModal(false);
            setOpenAddCommentsModal(true);
            setDocument(document);
          }}
        />
      )}

      {openAddCommentsModal && (
        <AddCommentModal
          onSubmit={() => {}}
          onCancel={() => setOpenAddCommentsModal(false)}
        />
      )}

      {openPdfModal && (
        <PdfModalViewer
          clearDocument={() => {}}
          document={{
            id: 2,
            name: "ПУ-1-3.2-22-РД-КЖ2.4.pdf",
            revisionNumber: 4,
            isUpdated: false,
          }}
        />
      )}
      <StyledProjectTitle>
        <StyledTitle>
          <button
            style={{ border: "none", background: "none" }}
            onClick={() => navigate("/main/projects/alximovo")}
          >
            <ArrowLeft />
          </button>

          <Typography.Title
            style={{ marginLeft: "14px", color: "#2B303B" }}
            level={3}
          >
            {`${sectionData.title} — ${sectionData.seriesTitle}`}
          </Typography.Title>
        </StyledTitle>

        <StyledButton type="primary">Создать заявку на ИЗМ </StyledButton>
      </StyledProjectTitle>

      <div>
        <Typography.Text
          style={{ marginLeft: "64px", marginBottom: "8px", color: "#6A7695" }}
        >
          Для производства работ используйте актуальную РД
        </Typography.Text>
      </div>

      <StyledWDCardWrapper>
        <WDCard
          title="Актуальная РД"
          versionType="actualVersion"
          extraContent={
            <StyledButtons>
              <Button
                type="link"
                style={{
                  padding: "4px 0px 4px 30px",
                }}
                onClick={() => setOpenDocumentsModal(true)}
              >
                Смотреть документы
              </Button>

              <Button
                type="link"
                style={{
                  padding: "4px 0px 4px 30px",
                }}
              >
                Открыть хранилище
              </Button>

              <Button
                type="default"
                style={{
                  color: "#4a5368",
                  borderRadius: "8px",
                  padding: "4px 20px",
                }}
                onClick={() => setOpenContractorsModal(true)}
              >
                Смотреть подрядчиков
              </Button>
            </StyledButtons>
          }
          documents={{
            id: 1,
            name: "aa",
            kitMark: "sdsd", // Марка комплекта РД
            code: "dds233", // Код комплекта
            previousVersions: [],
            actualVersion: {
              id: 1,
              version: 4,
              approved: true,
              createdAt: "01.01.2023",
              approvedAt: "07.01.2023",
              documents: [
                {
                  id: 11,
                  name: "Doc111",
                  revisionNumber: 555, // Версия файла
                  isUpdated: false,
                },
              ],
              status: EApproveStatus.UPDATED,
            },
            role: {
              isSuperuser: true,
              isContractor: true,
              isMember: true,
              contractorIsResponsible: true,
            },
          }}
        />

        <WDCard
          title="Новая РД"
          versionType="newVersion"
          extraContent={
            <StyledButtons>
              <Button
                type="link"
                style={{
                  padding: "4px 0px 4px 30px",
                }}
              >
                Смотреть документы
              </Button>

              <Button
                type="link"
                style={{
                  padding: "4px 0px 4px 30px",
                }}
              >
                Открыть хранилище
              </Button>

              <Button
                type="primary"
                style={{
                  borderRadius: "8px",
                  padding: "4px 20px",
                }}
              >
                Необходимо согласовать
              </Button>
            </StyledButtons>
          }
          documents={{
            id: 2,
            name: "bb",
            kitMark: "srerd", // Марка комплекта РД
            code: "sss333", // Код комплекта
            previousVersions: [],
            newVersion: {
              id: 2,
              version: 5,
              approved: false,
              createdAt: "05.01.2023",
              documents: [
                {
                  id: 22,
                  name: "Doc222",
                  revisionNumber: 666, // Версия файла
                  isUpdated: false,
                },
              ],
              status: EApproveStatus.UPDATED,
            },
            role: {
              isSuperuser: true,
              isContractor: true,
              isMember: true,
              contractorIsResponsible: true,
            },
          }}
        />
      </StyledWDCardWrapper>

      <TransparentCollapse
        title="Предыдущие версии"
        children={<TableDoc pagination={false} data={data} />}
      />
    </StyledWrapperSections>
  );
};
